import React from "react";
import { Link } from 'react-router-dom';
import Teams from '../../api/team';
import './TeamSection.css';

const TeamSection = () => {
    const teamMembers = Teams.filter((team) => team && team.id && team.tImg);
    const displayMembers = [...teamMembers, ...teamMembers];

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div className="wpo-team-area section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-7 col-xl-6">
                        <div className="wpo-section-title">
                            <span>Nuestro equipo</span>
                            <h2>Conoce nuestros voluntarios</h2>
                            <p>Contamos con un equipo multidisciplinario comprometido con el acompañamiento social, comunitario y humano de cada territorio.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="team-carousel">
                <div className="team-track">
                    {displayMembers.map((team, index) => (
                        <div className="team-card" key={`${team.id}-${index}`}>
                            <div className="team-card-img">
                                <Link onClick={ClickHandler} to={`/team-single/${team.id}`}>
                                    <img src={team.tImg} alt={team.name} />
                                </Link>
                            </div>
                            <div className="team-card-content">
                                <h2>
                                    <Link onClick={ClickHandler} to={`/team-single/${team.id}`}>
                                        {team.name}
                                    </Link>
                                </h2>
                                <span>{team.title}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TeamSection;